export default "__VITE_ASSET__f79NecTb__"